import { render, staticRenderFns } from "./CouponStore.vue?vue&type=template&id=72a86234&"
import script from "./CouponStore.vue?vue&type=script&lang=js&"
export * from "./CouponStore.vue?vue&type=script&lang=js&"
import style0 from "./CouponStore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports